import { sendApiRequest } from 'lib/api/public';

export type TrackOnboardingTaskId =
  | 'configure_candidate_email'
  | 'send_observer_link';

export type TrackOnboardingTaskRequest =
  | { taskId: 'configure_candidate_email'; candidateId: string }
  | { taskId: 'send_observer_link'; jobId: string };

export async function trackOnboardingTask(request: TrackOnboardingTaskRequest) {
  await sendApiRequest({
    path: '/account/track-onboarding-task',
    method: 'POST',
    data: request,
  });
}

export const getOnboardingTaskTrackRequest = (
  taskId: string,
  context: { jobId?: string | null; candidateId?: string | null },
): TrackOnboardingTaskRequest | null => {
  switch (taskId) {
    case 'configure_candidate_email':
      return context.candidateId ? { taskId, candidateId: context.candidateId } : null;
    case 'send_observer_link':
      return context.jobId ? { taskId, jobId: context.jobId } : null;
    default:
      return null;
  }
};
